module.exports = __webpack_public_path__ + "img/coal-vein.262429a6.png";